module.exports = __webpack_public_path__ + "assets/img/qq.42e72164.png";